import React, { useEffect, useState } from "react";
import { fetchModules, upsertModule } from "../../services/Administracion/modulesService";
import { Module } from "../../types/module";
import { formatDateUtil } from '../../utils/fechaUtil';

import { useAuth } from "../../context/AuthContext";
import ModuleModal from "./ModuleModal";

const ModuleList: React.FC = () => {
    const { user } = useAuth();
    const [modules, setModules] = useState<Module[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [selectedModule, setSelectedModule] = useState<Module>({ module_id: 0, module_name: '', description: '', icon_class: '', is_active: true, created_by: '', date_created: ''});
    const [showModal, setShowModal] = useState<boolean>(false);


    useEffect(() => {
        loadModules();
    }, []);


    const loadModules = async () => {
        setLoading(true);
        try {
            const data = await fetchModules();
            const processedModules = data.map((module: Module) => ({
                ...module,
            }));
            setModules(processedModules);
        } catch (error: any) {
            setError(error.message || "Error fetching modules");
        } finally {
            setLoading(false);
        }
    };

    const handleCreateModule = (module?: Module) => {
        console.log('Module a editar: ', module);
        setSelectedModule(module || { module_id: 0, module_name: '', description: '', icon_class: '', is_active: true, created_by: user?.User.email || '', date_created: '' });
        setShowModal(true);
    };



    const handleChangeStatusModule = async (module: Module) => {
        if (!module.module_id) return;
        if (!window.confirm(`¿Está seguro de desactivar el módulo: ${module.module_name}?`)) return;
        module.is_active = !module.is_active;
        try {
            await upsertModule(module);
            loadModules();
        } catch (error: any) {
            setError(error.message || "Error al desactivar el modulo"); //error.message es el mensaje que viene del servidor
        }
    };


    const handleSaveModule = async (module: Module) => {
        setLoading(true);
        try {
            if (module.module_id) {
                module.updated_by = user?.User.email;
            } else {
                module.created_by = user?.User.email || '';
            }
            await upsertModule(module);
            loadModules();
        } catch (error: any) {
            setError(error.message || "Error saving module");
        }
        setShowModal(false);
        setLoading(false);
    };

    if (loading) return <div className='container mt-4'>Cargando módulos...</div>;
    if (error) return <p>Error: {error}</p>


    return (
        <div className="container mt-4">
            <h4 className="mb-4">Mantenimiento de Módulos</h4>
            <div className="mb-3 text-end">
                <button className="btn btn-primary" onClick={() => handleCreateModule()}>
                    Crear Módulo
                </button>
            </div>
            <table className="table table-striped table-hover">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Nombre</th>
                        <th>Descripcion</th>
                        <th>Icono</th>
                        <th>Activo</th>
                        <th>Fecha Creación</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {modules.map((module) => (
                        <tr key={module.module_id}>
                            <td>{module.module_id}</td>
                            <td>{module.module_name}</td>
                            <td>{module.description}</td>
                            <td><i className={`${module.icon_class} me-2`}/>{module.icon_class}</td>
                            <td>{formatDateUtil(module.date_created)}</td>
                            <td>{module.is_active ? 'Si' : 'No'}</td>
                            <td>
                                <button className="btn btn-sm btn-secondary me-2" onClick={() => handleCreateModule(module)}>Editar</button>
                                <button
                                    className={`btn btn-sm ${module.is_active ? 'btn-danger' : 'btn-success'}`}
                                    onClick={() => handleChangeStatusModule(module)}
                                >
                                    {module.is_active ? 'Desactivar' : 'Activar'}
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {showModal && selectedModule && (
                <ModuleModal
                    module={selectedModule}
                    onClose={() => setShowModal(false)}
                    onSave={handleSaveModule}
                />
            )}
        </div>
    );
}

export default ModuleList;